import React, {useCallback, useContext, useEffect, useState} from 'react'
import {objectLang, setErrorWindow, setLocalStorageItem} from "../functions"
import {useHttp} from "../hooks/http.hook"
import config from "../config.json"
import {AuthContext} from "../context/AuthContext"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"

export const VerifyPage = () => {
    setLocalStorageItem('page', 'VerifyPage')
    const lang = objectLang().language
    const l = lang.lang
    const urlParams = new URLSearchParams(window.location.search)
    const {loading, request} = useHttp()
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [email, setEmail] = useState('')
    const [code, setCode] = useState('')
    const userId = urlParams.get('uid')
    const auth = useContext(AuthContext)
    // console.log(userId)

    const getUserEmail = useCallback(async () => {
        const lang = objectLang().language
        const l = lang.lang
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/user/getEmail/${userId}`,
                'GET',
                null
            )
            if (data['newAccessToken']) auth.accessToken = data['newAccessToken']
            setEmail(data.email)
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }, [request, userId, auth])

    useEffect(() => {
        getUserEmail().then()
    }, [getUserEmail])

    if (loading) {
        return <LoaderClass />
    }
    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>

        )
    }

    const changeCodeHandler = (event) => {
        setCode(event.target.value.toString())
    }

    const sendCodeHandler = async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/user/verify`,
                'POST',
                {
                    email: btoa(email),
                    verifyCode: btoa(code),
                    authenticated: auth.authenticatedVia
                })

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                setAllowed(false)
                setDataModal(setErrorWindow(
                    lang.body.verifyPage.title,
                    5541,
                    '',
                    '',
                    'replaceToAuth',
                    'off')
                )
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    const getCodeHandler = async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/user/get-verify-code-to-email`,
                'POST',
                {
                    email: btoa(email),
                    lang: l
                })

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                setAllowed(false)
                setDataModal(setErrorWindow(
                    lang.body.verifyPage.title,
                    '',
                    lang.body.verifyPage.description,
                    '',
                    `replaceTo /${l}/verify?uid=${userId}`,
                    'off')
                )
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    return (
        <>
            <div className={'container col-sm-9 col-xl-6 col-xxl-5'}>
                <div className={'rounded'}>
                    <fieldset className={'teal m-3 p-3'}>
                        <h1 id={"legend"} className={'fs-1'}>{lang.body.verifyPage.title}</h1>
                        <p id={"verify-description"} className={"m-0"}>{lang.body.verifyPage.description}</p>
                        <div id={"divVerify"} className={"mb-3"}>
                            <label
                                htmlFor={"verify"}
                                className={"form-label mt-3"}>
                                {lang.body.verifyPage.label}
                            </label>
                            <input
                                type={"text"}
                                name={"verify"}
                                id={"verify"}
                                className={"form-control"}
                                placeholder={lang.body.verifyPage.codePlaceholder}
                                onChange={changeCodeHandler}
                            />
                        </div>

                        <div className={"container d-flex justify-content-center"}>
                            <div className={"row"}>
                                <div className={"col-sm"}>
                                    <button
                                        id={"sendCode"}
                                        type={'button'}
                                        disabled={loading}
                                        className={"mt-2 me-2 btn btn-primary"}
                                        onClick={sendCodeHandler}>
                                        {lang.body.verifyPage.btnSendCode}
                                    </button>
                                    <button
                                        id={"sendAgain"}
                                        type={'button'}
                                        disabled={loading}
                                        className={"mt-2 me-2 btn btn-secondary"}
                                        onClick={getCodeHandler}>
                                        {lang.body.verifyPage.btnSendCodeAgain}
                                    </button>
                                    <button
                                        id={"btnBack"}
                                        type={'button'}
                                        disabled={loading}
                                        className={"mt-2 btn btn-warning"}
                                        onClick={() => {
                                            return window.location.replace('/auth-form')
                                        }}>
                                        {lang.body.verifyPage.btnBack}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </>
    )
}